var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-tile',{on:{"click":function($event){return _vm.pdfLabelsCall(_vm.artwork)}}},[_c('v-list-tile-title',[_vm._v("\n      Download Exhibition History\n    ")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-163bc498","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artworks/PdfEh.vue
// module id = +R/v
// module chunks = 1